import React from 'react';
import { classNames } from '@/shared/lib/classnames/classnames';
import type { ButtonVariants } from '@/shared/ui/button';
import { Button } from '@/shared/ui/button';
import inputIcons from '@/shared/assets/sprites/inputs.sprite.svg';
interface Props {
  direction: 'left' | 'right';
  onClick: () => void;
  ariaLabel: string;
  bgVariant?: ButtonVariants;
}
export const SliderButtons: React.FC<Props> = ({
  direction,
  onClick,
  ariaLabel,
  bgVariant
}) => {
  return <Button variant="circle" onClick={onClick} aria-label={ariaLabel} className={classNames('absolute top-1/2 z-10 size-7 -translate-y-1/2 shadow-md', {
    'left-[-12px]': direction === 'left',
    'right-[-12px]': direction === 'right',
    'bg-bgPrimary': bgVariant?.variant === 'default',
    'backdrop-saturate-2 bg-bgPrimary/10 text-white backdrop-blur-3xl': bgVariant?.variant === 'glassmorphism'
  })} data-sentry-element="Button" data-sentry-component="SliderButtons" data-sentry-source-file="SliderButtons.tsx">
      <svg className={classNames('size-5 fill-textPrimary', {
      '-rotate-90': direction === 'left',
      'rotate-90': direction === 'right'
    })} data-sentry-element="svg" data-sentry-source-file="SliderButtons.tsx">
        <use xlinkHref={`${inputIcons}#chevron-up`} data-sentry-element="use" data-sentry-source-file="SliderButtons.tsx"></use>
      </svg>
    </Button>;
};